var youboralib = require('youboralib');

var Util = youboralib.Util;
module.exports = {
  isUsed: function isUsed(adapter) {
    return !!adapter.getTech().hls;
  },
  getBitrate: function getBitrate(adapter) {
    var media = adapter.getTech().hls.playlists.media();
    if (media && media.attributes) return media.attributes.BANDWIDTH;
  },
  getRendition: function getRendition(adapter) {
    var media = adapter.getTech().hls.playlists.media();

    if (media && media.attributes) {
      var att = media.attributes;

      if (att.RESOLUTION) {
        return Util.buildRenditionString(att.RESOLUTION.width, att.RESOLUTION.height, att.BANDWIDTH);
      } else if (att.BANDWIDTH) {
        return Util.buildRenditionString(att.BANDWIDTH);
      } else if (att.NAME) {
        return att.NAME;
      }

      return null;
    }
  }
};